import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './Map.css';
import withStyles from '../../decorators/withStyles';
import { noaaExtremeLink, mappingChoicesLink, ss2link } from "../../utils/utils";


class Map extends Component {

  static propTypes = {
    waterLevel: PropTypes.object.isRequired,
    position: PropTypes.object.isRequired,
    mapLayer: PropTypes.string.isRequired,
    error: PropTypes.object,
    isVertical: PropTypes.bool
  };

  static defaultProps = {
    scenario: ""
  };

  mapID() {
    if (this.props.mapLayer === "noaa2017") {
      return "noaa2017-map";
    } else if (this.props.mapLayer === "mappingchoices") {
      return "mappingchoices-map";
    } else {
      return "summary-map";
    }
  }

  componentDidMount() {
    var Surging = require('./surging-dev/surging').default;
    require('./surging-dev/mapControl');
    if (this.props.mapLayer === "noaa2017") {
      const noaa2017Composer = require('./surging-dev/composer-noaa2017');
      this.map = new Surging.Map(this.mapID(), {
        center: [this.props.position.lat, this.props.position.lon],
        zoom: this.props.position.zoom,
        inboundLink: location.search,
        waterLayer: {stack: this.props.mapLayer},
        zoomControl: false,
        composer: noaa2017Composer,
        noaa2017: {
          scenario: this.props.scenario
        }
      });
      this.map.setStack(this.props.mapLayer);
    } else if (this.props.mapLayer === "mappingchoices") {
      const choicesComposer = require('./surging-dev/composer');
      const stack = 'lockin';

      this.mapA = new Surging.Map(this.mapID(), {
        center: [this.props.position.lat, this.props.position.lon],
        zoom: this.props.position.zoom,
        zoomControl: false,
        waterLayer: {stack},
        lockin: {
          'time-horizon': this.props.lockinYear,
          scenario: 'warming-4',
          compare:  this.props.compareMode,
        },
        composer: Object.assign({}, choicesComposer, {name: 'left'}),
        inboundLink: location.search
      });
      this.mapA.setStack(stack);

      this.mapB = new Surging.Map(this.mapID() + "2", {
        center: [this.props.position.lat, this.props.position.lon],
        zoom: this.props.position.zoom,
        zoomControl: false,
        waterLayer: {stack},
        lockin: {
          'time-horizon': this.props.lockinYear,
          compare:  this.props.compareMode,
          scenario: 'warming-2',
        },
        composer: Object.assign({}, choicesComposer, {name: 'right'}),
        inboundLink: location.search
      });
      this.mapB.setStack(stack);

      this.map = new Surging.Map.linkMaps([this.mapA, this.mapB]);

    } else {
      this.map = new Surging.Map(this.mapID(), {
        center: [this.props.position.lat, this.props.position.lon],
        zoom: this.props.position.zoom,
        inboundLink: location.search,
        waterLayer: {stack: this.props.mapLayer},
        zoomControl: false
      });
      this.mapControl = new Surging.Control.MapControl();
      this.map.addControl(this.mapControl);
      this.mapControl.setWaterLevel(this.props.waterLevel);
      this.map.setStack(this.props.mapLayer);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.waterLevel.level === this.props.waterLevel.level &&
        nextProps.waterLevel.unit === this.props.waterLevel.unit &&
        nextProps.position.lat === this.props.position.lat &&
        nextProps.position.lon === this.props.position.lon &&
        nextProps.position.zoom === this.props.position.zoom &&
        nextProps.isVertical === this.props.isVertical &&
        nextProps.mapLayer === this.props.mapLayer ) {
      return false;
    } else {
      return true;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.mapLayer !== "mappingchoices" && this.props.mapLayer !== "noaa2017") {
      this.mapControl.setWaterLevel(this.props.waterLevel);
      if (this.props.mapLayer !== prevProps.mapLayer) {
        this.map.setStack(this.props.mapLayer);
      }
    }

    if (this.props.mapLayer === "mappingchoices") {
      this.map.setVertical(this.props.isVertical);
    }

    // Set the map position if it is defined (object non-empty
    if (Object.keys(this.props.position).length !== 0) {
      if (this.props.mapLayer === "mappingchoices") {
        this.mapA.setView([this.props.position.lat, this.props.position.lon], this.props.position.zoom, {animate: true});
        this.mapB.setView([this.props.position.lat, this.props.position.lon], this.props.position.zoom, {animate: true});
      } else {
        this.map.setView([this.props.position.lat, this.props.position.lon], this.props.position.zoom, {animate: true});
      }
      // this.map.setView([this.props.position.lat, this.props.position.lon], this.props.position.zoom, {animate: true});
    }
  }

  render() {
    const { waterLevel, position, mapLayer } = this.props;

    var href;
    if (this.props.mapLayer === "noaa2017") {
      href = noaaExtremeLink(position, "extreme_p50");
    } else if (this.props.mapLayer === "mappingchoices") {
      href = mappingChoicesLink(position, "warming-4", "warming-2");
    } else {
      href = ss2link(waterLevel, position, mapLayer);
    }

    return !this.props.error ? (
      <div className="Map-column">
        <div className="Map">
          <div className="map-overlay">
            <div className="shield"></div>
            <a title="View in full-size map" href={href} target="_blank">
              {this.props.mapLayer !== "noaa2017" && this.props.mapLayer !== "mappingchoices" ?
                <span className="ss2link-container">
                  <span>FULL-FEATURE MAP</span>
                    <svg class="externallink" fill="#FFFFFF" height="22" width="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      {/*<path d="M0 0h24v24H0z" fill="none" />*/}
                      <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
                    </svg>
                </span>
              : null}
            </a>
            {this.props.mapLayer === "mappingchoices" ?
                <div style={{height: "100%", top: 0}} className="linked-maps">
                  {/*<div className="map-label-wrapper">
                    <button className="map-label text-regular medium">&nbsp;</button>
                  </div>*/}
                  <div id={this.mapID()} className="map"></div>
                  {/*<div className="map-label-wrapper">
                    <button className="map-label text-regular medium">&nbsp;</button>
                  </div>*/}
                  <div id={this.mapID() + "2"} className="map"></div>
                </div>
                  :
                <div id={this.mapID()} className="map"></div>
            }
          </div>
        </div>
        {this.props.children}
      </div>
    ) : this.props.children;
  }
}

export default withStyles(styles)(Map);
